import { atom } from 'recoil'

import { localStorageEffect } from '../common/commonAtoms'

import { CustomerMapper } from './CustomerMapper'
import { CustomerModel } from './type'

export const authenticatedCustomerState = atom<CustomerModel>({
  key: 'authenticated_customer',
  default: CustomerMapper.defaultValue,
  effects: [localStorageEffect('authenticated_customer')],
})
